import { CTA, ReviewPageConfig, ReviewPageConfigSettings, normalizeCTA } from "@/services/bedrock";

type LiquidField = "headline" | "subtitle";
type LiquidFieldErrors = Partial<Record<LiquidField, string>>;

const getReviewPageSettings = (config: ReviewPageConfig): ReviewPageConfigSettings => ({
  formId: config.formId ?? null,
  contentPageThemeId: config.contentPageThemeId ?? null,
  headline: config.headline ?? null,
  subtitle: config.subtitle ?? null,
  showStarSummary: config.showStarSummary,
  showSentimentSummary: config.showSentimentSummary,
  showNpsSummary: config.showNpsSummary,
  approvedForSocialOnly: config.approvedForSocialOnly,
  reviewSortType: config.reviewSortType,
  showReviewReplies: config.showReviewReplies,
  showSourceFilter: config.showSourceFilter,
  showOfficeDetails: config.showOfficeDetails,
  showSocialLinks: config.showSocialLinks,
  callToAction: normalizeCTA(config.callToAction),
});

const callToActionParams = (cta: CTA | null): [string, string][] => {
  if (!cta) return [["callToAction", ""]];
  const { label, type, customLink, formId, smartLinkId } = cta;
  return Object.entries({ label, type, customLink, formId, smartLinkId })
    .filter(([, value]) => value !== null && value !== undefined)
    .map(([key, value]) => [`callToAction[${key}]`, String(value)]);
};

const reviewPagePreviewParams = (settings: Partial<ReviewPageConfigSettings>): URLSearchParams => {
  const { callToAction, ...rest } = settings;
  return new URLSearchParams([
    ...Object.entries(rest).map(([key, value]): [string, string] => [
      key,
      value === null || value === undefined ? "" : String(value),
    ]),
    ...(callToAction === undefined ? [] : callToActionParams(callToAction)),
  ]);
};

const LIQUID_FIELDS: LiquidField[] = ["headline", "subtitle"];

const liquidFieldErrors = (error: unknown): LiquidFieldErrors => {
  const fields: Partial<Record<string, string[]>> = (error as { fields?: object } | null)?.fields ?? {};
  return Object.fromEntries(
    LIQUID_FIELDS.flatMap(field => (fields[field]?.length ? [[field, `${fields[field][0]}.`]] : []))
  );
};

export { getReviewPageSettings, reviewPagePreviewParams, liquidFieldErrors };
export type { LiquidField, LiquidFieldErrors };
